// An empty state: nothing to show yet, or a part that arrives in a later stage.
export default function ComercialVacio({ titulo, texto, children }) {
  return (
    <div className="bg-white rounded-xl border border-dashed border-gray-300 px-6 py-10 text-center">
      {titulo && <p className="text-sm font-medium text-gray-800">{titulo}</p>}
      {texto && <p className="text-sm text-gray-500 mt-1 max-w-md mx-auto">{texto}</p>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  )
}
